export const NetworkErrorCodes = {
	FORBIDDEN: "FORBIDDEN",
	UNAUTHORIZED: "UNAUTHORIZED",
	BAD_REQUEST: "BAD_REQUEST",
};
